module.exports = __webpack_public_path__ + "img/tip.8af2da0a.png";